import { IOrderApproval } from "./../interfaces/IOrderApproval";
import { ICartItem } from "../interfaces/ICartItem";
import EnvironmentService from "./environmentService";
import { IListItemAction } from "@wbmason/my-list-service";

export function IsEcom() {
  return typeof EnvironmentService.get().isEcom === "undefined"
    ? true
    : EnvironmentService.get().isEcom;
}

export const ApiEndpointResolver = {
  getTabSetsSubCategoriesUrl(categoryId: string) {
    if (IsEcom() || !EnvironmentService.get().tabSetsSubCategoriesUrl) {
      const key = `TabSet/Categories/${categoryId}`;
      return EnvironmentService.get().ecomApi + key;
    } else {
      return EnvironmentService.get().tabSetsSubCategoriesUrl.replace(
        "/:categoryId",
        "/" + categoryId,
      );
    }
  },
  getTabSetsCategoriesUrl() {
    if (IsEcom() || !EnvironmentService.get().getTabSetsCategoriesUrl) {
      return EnvironmentService.get().ecomApi + "TabSet/Categories";
    } else {
      return EnvironmentService.get().getTabSetsCategoriesUrl;
    }
  },
  getOrderApprovalsUrl() {
    if (IsEcom() || !EnvironmentService.get().getOrderApprovalsUrl) {
      return (
        EnvironmentService.get().ecomApi +
        "OrdersAwaitingApproval?pageSize=3&includeAddresses=true"
      );
    } else {
      return EnvironmentService.get().getOrderApprovalsUrl;
    }
  },
  approveRejectOrderUrl(order: IOrderApproval) {
    if (IsEcom() || !EnvironmentService.get().approveRejectOrderUrl) {
      return (
        EnvironmentService.get().ecomApi +
        "OrdersAwaitingApproval/ApproveReject"
      );
    } else {
      return EnvironmentService.get().approveRejectOrderUrl.replace(
        "/:approvalGuid",
        "/" + order.approvalGuid,
      );
    }
  },
  getCartItemsUrl() {
    if (IsEcom() || !EnvironmentService.get().getCartItemsUrl) {
      return (
        EnvironmentService.get().ecomGatewayApi + "Cart/Items?withCoupons=false"
      );
    } else {
      return EnvironmentService.get().getCartItemsUrl;
    }
  },
  getUserBudgetUrl() {
    if (IsEcom() || !EnvironmentService.get().getUserBudgetUrl) {
      return EnvironmentService.get().ecomApi + "Budget/User";
    } else {
      return EnvironmentService.get().getUserBudgetUrl;
    }
  },
  getItemIndicatorsUrl() {
    if (IsEcom() || !EnvironmentService.get().getItemIndicatorsUrl) {
      return EnvironmentService.get().ecomGatewayApi + "ItemIndicators";
    } else {
      return EnvironmentService.get().getItemIndicatorsUrl;
    }
  },
  getDeliveryNotificationsUrl() {
    if (IsEcom() || !EnvironmentService.get().getDeliveryNotificationsUrl) {
      return EnvironmentService.get().ecomApi + "DeliveryNotification";
    } else {
      return EnvironmentService.get().getDeliveryNotificationsUrl;
    }
  },
  removeCartItemUrl(cartItem: ICartItem) {
    if (IsEcom() || !EnvironmentService.get().removeCartItemUrl) {
      return (
        EnvironmentService.get().ecomApi +
        `Cart/Item/Remove/${cartItem.cartLineRecId}`
      );
    } else {
      return EnvironmentService.get().removeCartItemUrl.replace(
        "/:recId",
        "/" + cartItem.cartLineRecId,
      );
    }
  },
  getBudgetTypeUrl() {
    if (IsEcom() || !EnvironmentService.get().getBudgetTypeUrl) {
      return EnvironmentService.get().ecomApi + "Budget/Type";
    } else {
      return EnvironmentService.get().getBudgetTypeUrl;
    }
  },
  getDeliveryAddressesUrl() {
    if (IsEcom() || !EnvironmentService.get().getDeliveryAddressesUrl) {
      return EnvironmentService.get().ecomGatewayApi + "Addresses/Delivery";
    } else {
      return EnvironmentService.get().getDeliveryAddressesUrl;
    }
  },
  setShoppingLocationUrl() {
    if (IsEcom() || !EnvironmentService.get().setShoppingLocationUrl) {
      return EnvironmentService.get().ecomApi + "ShoppingLocation";
    } else {
      return EnvironmentService.get().setShoppingLocationUrl;
    }
  },
  getShoppingLocationUrl() {
    if (!IsEcom() || EnvironmentService.get().getShoppingLocationUrl) {
      return EnvironmentService.get().getShoppingLocationUrl;
    }

    return "";
  },
  getShoppingLocationByZipCode(zipCode: string, registrationType: string) {
    let url: string;
    if (IsEcom() || !EnvironmentService.get().getShoppingLocationByZipCodeUrl) {
      url = EnvironmentService.get().ecomApi + "ShoppingLocation/GetFromZip";
      return (
        url + "?zipCode=" + zipCode + "&registrationType=" + registrationType
      );
    } else {
      return EnvironmentService.get().getShoppingLocationByZipCodeUrl.replace(
        "/:zipCode",
        "/" + zipCode + "?registrationType=" + registrationType,
      );
    }
  },
  getProductAvailabilityUrl(
    dlvMode?: string,
    apiName?: string,
    altAddressRecId?: string,
    state?: string,
    zipCode?: string,
  ) {
    if (IsEcom() || !EnvironmentService.get().getProductAvailabilityUrl) {
      return (
        EnvironmentService.get().ecomGatewayApi +
        "ProductAvailability/Items_v2" +
        "?dlvMode=" +
        dlvMode +
        "&version=" +
        apiName +
        "&altAddressRecId=" +
        altAddressRecId +
        (state ? "&state=" + state : "") +
        (zipCode ? "&zipCode=" + zipCode : "")
      );
    } else {
      return EnvironmentService.get().getProductAvailabilityUrl;
    }
  },
  saveWorkflowUrl() {
    if (IsEcom() || !EnvironmentService.get().saveWorkflowUrl) {
      return (
        EnvironmentService.get().ecomApi + "OrdersAwaitingApproval/Workflow"
      );
    } else {
      return EnvironmentService.get().saveWorkflowUrl;
    }
  },
  getInkAndTonerDevicesUrl(brand: string, searchFinderType: string) {
    let url: string;
    if (IsEcom() || !EnvironmentService.get().getInkAndTonerDevicesUrl) {
      url =
        EnvironmentService.get().ecomGatewayApi + `inkandtoner/device/${brand}`;
    } else {
      url = EnvironmentService.get()
        .getInkAndTonerDevicesUrl.replace("/:brandId", "/" + brand)
        .replace("/:type", "/" + searchFinderType);
    }

    return url + `?type=${searchFinderType}`;
  },
  getInkAndTonerModelsUrl(
    brand: string,
    device: string,
    searchFinderType: string,
  ) {
    let url: string;
    if (IsEcom() || !EnvironmentService.get().getInkAndTonerModelsUrl) {
      url =
        EnvironmentService.get().ecomGatewayApi +
        `inkandtoner/models/${brand}/${device}`;
    } else {
      url = EnvironmentService.get()
        .getInkAndTonerModelsUrl.replace("/:brandId", "/" + brand)
        .replace("/:deviceId", "/" + device)
        .replace("/:type", "/" + searchFinderType);
    }

    return url + `?type=${searchFinderType}`;
  },
  getInkAndTonerPayloadUrl() {
    if (IsEcom() || !EnvironmentService.get().getInkAndTonerPayloadUrl) {
      return EnvironmentService.get().ecomGatewayApi + "inkandToner/payload";
    } else {
      return EnvironmentService.get().getInkAndTonerPayloadUrl;
    }
  },
  getListItemsUrl() {
    if (IsEcom() || !EnvironmentService.get().getListItemsUrl) {
      return EnvironmentService.get().ecomGatewayApi + "FavoriteLists/Items";
    } else {
      return EnvironmentService.get().getListItemsUrl;
    }
  },
  getListsUrl(hideAccountLists: boolean | null) {
    if (IsEcom() || !EnvironmentService.get().getListsUrl) {
      return (
        EnvironmentService.get().ecomApi + "Lists/Items?displayAsList=true"
      );
    } else {
      const qs = hideAccountLists ? "hideAccountLists=true" : "displayAsListOnly=true";
      return `${EnvironmentService.get().getListsUrl}?${qs}`;
    }
  },
  selectListUrl() {
    if (IsEcom() || !EnvironmentService.get().selectListUrl) {
      return EnvironmentService.get().ecomApi + "SelectList/v2";
    } else {
      return EnvironmentService.get().selectListUrl;
    }
  },
  getDepartmentsUrl() {
    if (IsEcom() || !EnvironmentService.get().getDepartmentsUrl) {
      return EnvironmentService.get().ecomGatewayApi + "Departments";
    } else {
      return EnvironmentService.get().getDepartmentsUrl;
    }
  },
  getTypeAheadUrl() {
    if (IsEcom() || !EnvironmentService.get().getTypeAheadUrl) {
      return EnvironmentService.get().ecomApi + "TypeAhead";
    } else {
      return EnvironmentService.get().getTypeAheadUrl;
    }
  },
  getCustomerInvoiceParametersUrl() {
    if (IsEcom() || !EnvironmentService.get().getCustomerInvoiceParametersUrl) {
      return (
        EnvironmentService.get().ecomGatewayApi + "oi/CustomerInvoiceParam"
      );
    } else {
      return EnvironmentService.get().getCustomerInvoiceParametersUrl;
    }
  },
  getArContactUrl() {
    if (IsEcom() || !EnvironmentService.get().getArContactUrl) {
      return (
        EnvironmentService.get().ecomGatewayApi + "CustomerService/ARContact"
      );
    } else {
      return EnvironmentService.get().getArContactUrl;
    }
  },
  getCustomerServiceUrl() {
    if (IsEcom() || !EnvironmentService.get().getCustomerServiceUrl) {
      return EnvironmentService.get().ecomApi + "CustomerService";
    } else {
      return EnvironmentService.get().getCustomerServiceUrl;
    }
  },
  wheresMyStuffUrl(deliveryStatusEndpoint: string) {
    if (IsEcom() || !EnvironmentService.get().wheresMyStuffUrl) {
      return (
        EnvironmentService.get().ecomGatewayApi +
        "Delivery/MergeByStatus/" +
        deliveryStatusEndpoint
      );
    } else {
      return EnvironmentService.get().wheresMyStuffUrl.replace(
        "/:deliveryStatusEndpoint",
        "/" + deliveryStatusEndpoint,
      );
    }
  },
  getEmployeeContactsUrl() {
    if (IsEcom()) {
      return null;
    } else {
      return EnvironmentService.get().getEmployeeContactsUrl;
    }
  },
  getNavigationTokensUrl() {
    if (IsEcom() || !EnvironmentService.get().getNavigationTokensUrl) {
      return EnvironmentService.get().ecomApi + "Navigation/TokenUrl?";
    } else {
      return EnvironmentService.get().getNavigationTokensUrl + "?";
    }
  },
  getPropsUrl(redirectUrl: string) {
    return EnvironmentService.get().getPropsUrl + `?redirectUrl=${redirectUrl}`;
  },
  getConfigPropsUrl() {
    if (IsEcom() || !EnvironmentService.get().getNavigationTokensUrl) {
      return EnvironmentService.get().ecomApi + "ConfigProp?";
    } else {
      return EnvironmentService.get().getConfigPropsUrl + "?";
    }
  },
  getAddressFromRegCookieUrl() {
    return EnvironmentService.get().getAddressFromRegCookieUrl;
  },
  getLoginUrl() {
    return EnvironmentService.get().getLoginUrl;
  },
  getLogoutUrl() {
    return EnvironmentService.get().getLogoutUrl;
  },
  getDigitalDataUrl() {
    return EnvironmentService.get().getDigitalDataUrl;
  },
  getPricedProductUrl() {
    if (IsEcom() || !EnvironmentService.get().getPricedProductUrl) {
      return EnvironmentService.get().ecomApi + "itemprice/pricedproduct";
    } else {
      return EnvironmentService.get().getPricedProductUrl;
    }
  },
  getLogCompanyMatchUrl() {
    if (IsEcom() || !EnvironmentService.get().logCompanyMatchUrl) {
      return EnvironmentService.get().ecomApi + "CompanyMatch";
    } else {
      return EnvironmentService.get().logCompanyMatchUrl;
    }
  },
};
